<template>
  <div class="stacked-combobox-container">
    <v-combobox
      v-model="localValue"
      v-bind="{ ...$attrs, ...commonAttrs }"
      v-on="$listeners"
      chips
      multiple
      :items="possibleOptions"
      :no-data-text="$t('general.no_data')"
      @input="handleInput"
      item-value="key"
      item-text="label"
      attach
    >
      <template #selection="{ item, selected }">
        <v-chip
          :input-value="selected"
          close
          color="white"
          @click:close="remove(item)"
        >
          <v-icon small v-if="preferredOption && preferredOption === item">
            mdi-star
          </v-icon>
          {{ item.label || item }}
        </v-chip>
      </template>

    </v-combobox>

    <div v-if="showSelectableOptions && selectableOptions.length > 0 && !disabled" class="mt-2 pb-4">
      <MultiChip
        small
        :chips="selectableOptions"
        @click:chip="addOption"
      >
        <template #chip="{ chip }">
          <v-icon small v-if="preferredOption && preferredOption === chip">
            mdi-star
          </v-icon>
          {{ chip.label || chip }}
        </template>
      </MultiChip>
    </div>
  </div>
</template>

<script>
import { difference } from 'lodash';
import localValue from '@/mixins/localValue';
import MultiChip from '@/components/MultiChip.vue';

export default {
  name: 'StackedCombobox',
  inheritAttrs: false,
  components: {
    MultiChip,
  },
  mixins: [localValue],
  props: {
    possibleOptions: {
      type: Array,
      default: () => [],
    },
    preferredOption: {
      type: [String, Number, Boolean],
      default: undefined,
    },
    showSelectableOptions: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    commonAttrs() {
      return {
        hideDetails: this.$attrs.hideDetails || 'auto',
        disabled: this.disabled,
      };
    },
    selectableOptions() {
      return difference(this.possibleOptions, (this.localValue || []));
    },
  },
  methods: {
    addOption(option) {
      let newValue;
      if (this.localValue) {
        if (!this.localValue.includes(option)) {
          // Create a new array with the added option
          newValue = [...this.localValue, option];
        } else {
          // If option already exists, no change needed
          return;
        }
      }
      // Emit the updated value to trigger the parent's setter
      this.$emit('input', newValue);
    },
    remove(item) {
      const index = this.localValue.indexOf(item);
      if (index >= 0) {
        // Create a new array without the removed item
        const newValue = [...this.localValue];
        newValue.splice(index, 1);

        // Emit the updated value to trigger the parent's setter
        this.$emit('input', newValue);
      }
    },
    handleInput(value) {
      // If the last item is not in possibleOptions, remove it
      if (value && Array.isArray(value) && value.length > 0) {
        const lastItem = value[value.length - 1];
        if (typeof lastItem === 'string' && !this.possibleOptions.includes(lastItem)) {
          value.pop(); // Remove the last item if it's not in possibleOptions
        }
      }
      this.localValue = value;
    },
  },
}
</script>

<style lang="scss" scoped>
.stacked-combobox-container {
  width: 100%;
}

.v-select__selections {
  flex-wrap: wrap;
}
</style>
